export function toInstant(value) {
  if (value == null || value === '') return null
  if (value instanceof Date) return value
  if (typeof value === 'number') return new Date(value)

  let s = String(value).trim()

  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s)
  if (dateOnly) {
    const [, y, m, d] = dateOnly
    return new Date(Number(y), Number(m) - 1, Number(d))
  }

  const hasTz = /([zZ])$|[+-]\d{2}(:?\d{2})?$/.test(s)
  s = s.replace(' ', 'T')
  if (!hasTz) s += 'Z'

  const date = new Date(s)
  return Number.isNaN(date.getTime()) ? null : date
}

export const DATE_PRESETS = {
  date: { month: 'short', day: 'numeric', year: 'numeric' },
  dateLong: { month: 'long', day: 'numeric', year: 'numeric' },
  dateNumeric: { month: 'numeric', day: 'numeric', year: 'numeric' },
  time: { hour: '2-digit', minute: '2-digit' },
  dateTime: { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' },
}

export function formatInstant(value, preset = 'date', locale) {
  const date = toInstant(value)
  if (!date) return ''
  return new Intl.DateTimeFormat(locale, DATE_PRESETS[preset] ?? preset).format(date)
}
